export default {
  baseURL: "https://quoteyrating.nerivon.cloud/api",
};
